module.exports = __webpack_public_path__ + "media/images/sufybanner-c1f3a667.png";